export default "__VITE_ASSET__COCJhvy2__"